module.exports = __webpack_public_path__ + "img/decorator-music.dd14766d.png";